import script from "./payslip-detail.vue?vue&type=script&setup=true&lang=js"
export * from "./payslip-detail.vue?vue&type=script&setup=true&lang=js"

import "./payslip-detail.vue?vue&type=style&index=0&id=59b653c3&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59b653c3"]])

export default __exports__